<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    
    <TableView
      :headers="headers"
      :items="merchants"
      :options.sync="options"
      :loading="loading"
      :totalData="totalMerchants"
      :refresh-table="getData"
      :bodyFilter="true"
      item-key="id"
      table-height="70vh"
    >     
        <template v-slot:body-prepend>
          <TablefilterResendEmail :search.sync="search" :options.sync="options" v-on:getDataParent="getData" />
        </template>
        <template v-slot:action="{ item }">
          <td>
              <v-btn
                color="warning"
                x-small
                v-if="!item.disabled"
                @click="openDialogResend(item)"
                >Resend</v-btn
              >
            </td>
        </template>
    </TableView>
      <v-dialog v-model="dialogResend" width="500" persistent>
      <v-card>
        <v-card-title> Are you sure want to resend email ? </v-card-title>
        <v-card-text> Caution: this action cannot be undone ! </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn dark color="red" @click="() => (dialogResend = false)">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="resend"
            :disabled="loading"
            :loading="loading"
          >
            Resend
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import resendEmailMixin from '../../components/resend-email/resendEmailMixin';
import  TablefilterResendEmail  from '../../components/resend-email/components';

export default {
  mixins: [resendEmailMixin],
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TablefilterResendEmail
  },

};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
